import {changeEvent, documentLoadEvent} from "../../../../webpack/modules/events";
import {initProductImageSlider} from "../../../../webpack/modules-optimized/product-list";
import {getWishListItems, updateWishListButton} from "../../../../webpack/modules-optimized/wishlist";
import {onVisible} from "../../../../scripts/Tools/visible-element-observer";

let forcedImageDisplay = false;
documentLoadEvent(function() {
    fillWishListButtons();
    onVisible(document.querySelectorAll('#product-list-page .product .embla-carousel'), function(slider) {
        let imageDisplay = document.querySelector('#product-list-page .image-display-selector:checked').value;
        initProductImageSlider(slider, imageDisplay, forcedImageDisplay);
    }, 0.1);
});

changeEvent('#product-list-page .image-display-selector', false, function() {
    let imageDisplay = document.querySelector('#product-list-page .image-display-selector:checked').value;
    let notInitializedSliders = document.querySelectorAll('#product-list-page .product .embla-container:not(.embla-initialized)');

    notInitializedSliders.forEach(function(slider) {
        let track = slider.querySelector('.embla-track');
        let slides = slider.querySelectorAll('.embla-slide').length;

        if (imageDisplay === 'product') track.style.transform = `translate3d(-${(slides - 1) * 100}%, 0px, 0px)`;
        else track.style.transform = 'translate3d(0px, 0px, 0px)';
    });

    forcedImageDisplay = true;
});

async function fillWishListButtons()
{
    let wishListItems = await getWishListItems();
    if (!wishListItems) return;
    document.querySelectorAll('#product-list-page .add-item-wish-list').forEach(function(button) {
        if (wishListItems.includes(parseInt(button.dataset.productId))) updateWishListButton(button, true);
    });
}